import { schema } from '~/constants/auth';
import yup from '~/utils/validation';

export const SignUpConfirmationFormSchema = yup.object().shape({
    code: schema.verificationCode,
});
